// extracted by mini-css-extract-plugin
module.exports = {"CommentMenu__item--admin":"w_a","CommentMenu__item--moderator":"w_b"};